import * as appsettings from "../appsettings";
import * as main from "../main";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

export function checkboxTemplate(ploegnaamId: number, capcode: number, serviceFunctionId: number, hidden: boolean, isChecked: boolean): string {
    let checked = "";
    let style = "";
    if (isChecked)
    {
        checked = "checked ";
    }    
    if (hidden)
    {
        style = "style='display: none;' ";
    }

    var templateHtml = "<div style='text-align: center;'>" +
                       "<input type='checkbox' " +
                       "name='" + ploegnaamId + "_" + capcode + "_" + serviceFunctionId + "' " +
                       checked + style +
                       "onChange='PreCom.Modules.crewServiceFunction.onChangeGranted(event)' />" +
                       "</div>";

    return templateHtml;
}

export function onChangeGranted(e: Event): void {
    const checkbox = e.target as HTMLInputElement;
    const [ploegnaamId, capcode, serviceFunctionId] = checkbox.name.split("_").map(Number);
    var granted = checkbox.checked;

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("CrewServiceFunction/Update_CrewServiceFunction"),
        data: { ploegnaamId: ploegnaamId, capcode: capcode, serviceFunctionId: serviceFunctionId, granted: granted },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {
            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}
